/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Rozszerzenia/modyfikacje komponentów Boostrap
 *
 * @class BootstrapExtensions
 * @extends {PopoverExtension}
 */

import { PopoverExtension } from "./PopoverExtension.class"

export class BootstrapExtensions extends PopoverExtension {
	constructor(options) {
		super(options);
		var defaults = {};
		this.settings = $.extend({}, defaults, options);
	}
	// ****************************************************************************************************
	// Inicjalizacja Rozszerzen/modyfikacji Boostrap
	// ****************************************************************************************************
	init() {
		var that = this;
		that.initDropdowns();
	}
}